
const userMeta = {
    name: "systemuser",
    page: "admin",
    ui:"false",
    fields: [
        {name: "user_id", type: "SERIAL PRIMARY KEY", show: "false"},
        {name: "type_auth", type: "text", show: "false"},
        {name: "rt", type: "text", place: "head", show: "false"},
        {name: "roles", type: "enum_role", show: "true"},
        {name: "name", type: "text", show: "true"},
        {name: "password", type: "text", show: "true"},
        // {name: "mail", type: "text", show: "true"},
        {name: "is_blocked", type: "boolean", show: "true"},
        // {name: "exc", type: "timestamp", show: "true"},
        {name: "descr", type: "text", show: "true"},
        {name: "data", type: "obj", show: "false"},
        
        // {name: "id", type: "SERIAL PRIMARY KEY", show: "false"},
        // {name: "version", type: "text", show: "false"},
        // {name: "type_auth", type: "text", show: "false"},
        // {name: "name", type: "text", show: "true"},
        // {name: "blocked", type: "boolean", show: "true"},
        // {name: "role", type: "enum_role", show: "true"},
        // {name: "password", type: "text", show: "true"},
        // {name: "comment", type: "text", show: "true"},
        // {name: "email", type: "text", show: "true"},
        // {name: "sms_phone", type: "text", description: "like: +79242743313,+79162342134 (for multiple numbers)", show: "true"},
        // {name: "push_active", type: "text", show: "true"},
        // {name: "config", type: "json", show: "false"},
        // {name: "last_update_user", type: "text", place: "head", show: "false"},
        // {name: "last_update_date", type: "TIMESTAMP WITH TIME ZONE", place: "head", show: "false"}
    ],
    // refs: [
    //     {name: "person", cls: "person", show: "false"}
    // ]
}

export default userMeta